import { Input } from "antd";
import React, { useEffect, useState } from "react";

const getColorBasedOnValue = (value, alarm_Data) => {
  const numValue = parseFloat(value);
  if (isNaN(numValue)) {
    return "grey";
  }

  // Use alarm_Data safely
  const orange = parseFloat(alarm_Data?.orange || 0);
  const red = parseFloat(alarm_Data?.red || 0);
  const max = parseFloat(alarm_Data?.max || 0);

  switch (true) {
    case numValue < orange:
      return "green";
    case numValue >= orange && numValue < red:
      return "orange";
    case numValue >= red && numValue <= max:
      return "red";
    default:
      return "grey";
  }
};

export default function SetAlarm({ get_json, set_json }) {
  const [max, setMax] = useState("");
  const [orange, setOrange] = useState("");
  const [red, setRed] = useState("");

  // Update state when get_json changes
  useEffect(() => {
    if (get_json) {
      setMax(get_json.max || "");
      setOrange(get_json.orange || "");
      setRed(get_json.red || "");
    }
  }, [get_json]);

  // Update the parent state whenever any of the values change
  useEffect(() => {
    set_json({ max, orange, red });
  }, [max, orange, red, set_json]);

  return (
    <div className="row" style={{ gap: "20px", margin: "0px" }}>
      <Input
        disabled
        placeholder="Maximum"
        value={max}
        onChange={(e) => setMax(e.target.value)}
        style={{
          borderColor: getColorBasedOnValue(max, get_json),
          borderWidth: "1.5px",
          borderStyle: "solid",
          color: getColorBasedOnValue(max, get_json),
        }}
      />
      <Input
        disabled
        placeholder="Orange"
        value={orange}
        onChange={(e) => setOrange(e.target.value)}
        style={{
          borderColor: getColorBasedOnValue(orange, get_json),
          borderWidth: "1.5px",
          borderStyle: "solid",
          color: getColorBasedOnValue(orange, get_json),
        }}
      />
      <Input
        disabled
        placeholder="Red"
        value={red}
        onChange={(e) => setRed(e.target.value)}
        style={{
          borderColor: getColorBasedOnValue(red, get_json),
          borderWidth: "1.5px",
          borderStyle: "solid",
          color: getColorBasedOnValue(red, get_json),
        }}
      />
    </div>
  );
}
